export default "__VITE_ASSET__DDDe666e__"